import { cloneElement } from "react";

export default function Tooltip({ tooltipText, children }) {
    const ClonedChildren = cloneElement(children, { className: children.props.className + " tooltip", "data-tooltip": tooltipText });
    return ClonedChildren;
}
